import React from 'react';
import PropTypes from 'prop-types';

const { headoffice, UI } = Mobi2Go;

class Policies extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        classPrefix: PropTypes.string.isRequired,
    };

    onTermsAndConditionsClick = e => {
        e.preventDefault();
        UI.trigger('showPolicy', 'termsandconditions');
    };

    onRefundsClick = e => {
        e.preventDefault();
        UI.trigger('showPolicy', 'refund');
    };

    onCancellationsClick = e => {
        e.preventDefault();
        UI.trigger('showPolicy', 'cancellation');
    };

    onDeliveriesClick = e => {
        e.preventDefault();
        UI.trigger('showPolicy', 'delivery');
    };

    onLoyaltyClick = e => {
        e.preventDefault();
        UI.trigger('showPolicy', 'loyalty');
    };

    getTermsAndConditionsLink() {
        return (
            <a
                className={`${this.props.classPrefix}__terms-and-conditions`}
                data-termsandconditions
                href="#"
                onClick={this.onTermsAndConditionsClick}
                key="termsandconditions"
            >
                {this.props.t('terms_and_conditions')}
            </a>
        );
    }

    getRefundsLink() {
        return (
            <a
                className={`${this.props.classPrefix}__refunds`}
                data-refund
                href="#"
                onClick={this.onRefundsClick}
                key="refund"
            >
                {this.props.t('refunds')}
            </a>
        );
    }

    getCancellationsLink() {
        return (
            <a
                className={`${this.props.classPrefix}__cancellations`}
                data-cancellation
                href="#"
                onClick={this.onCancellationsClick}
                key="cancellation"
            >
                {this.props.t('cancellations')}
            </a>
        );
    }

    getDeliveriesLink() {
        return (
            <a
                className={`${this.props.classPrefix}__deliveries`}
                data-delivery
                href="#"
                onClick={this.onDeliveriesClick}
                key="delivery"
            >
                {this.props.t('deliveries')}
            </a>
        );
    }

    getLoyaltyLink() {
        return (
            <a
                className={`${this.props.classPrefix}__loyalty`}
                data-loyalty
                href="#"
                onClick={this.onLoyaltyClick}
                key="loyalty"
            >
                {this.props.t('loyalty')}
            </a>
        );
    }

    render() {
        const { policy_visibility } = headoffice;

        const policy_links = [
            policy_visibility.refund ? this.getRefundsLink() : null,
            policy_visibility.cancellation ? this.getCancellationsLink() : null,
            policy_visibility.delivery ? this.getDeliveriesLink() : null,
            policy_visibility.loyalty ? this.getLoyaltyLink() : null
        ].filter(e => e !== null);

        return (
            <div className={this.props.classPrefix}>
                {policy_visibility.termsandconditions && [
                    this.getTermsAndConditionsLink(),
                    policy_links.length ? <br key="line-separator" /> : null,
                ]}
                {policy_links.map((link, index) => {
                    return [
                        link,
                        index !== policy_links.length - 1 ? (
                            <span key={index}> - </span>
                        ) : null,
                    ];
                })}
            </div>
        );
    }
}

export default Policies;
